(function () {
  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function getCodes(select) {
    return Array.from(select.options).map(function (opt) {
      return { value: opt.value, iso: opt.getAttribute('data-iso') || '', len: opt.value.length - 1 };
    }).sort(function (a, b) {
      return b.len - a.len;
    });
  }

  function splitPhone(full, codes) {
    var raw = String(full || '').trim();
    if (!raw) return { code: '', local: '' };

    if (raw.charAt(0) === '+') {
      var digits = '+' + digitsOnly(raw);
      for (var i = 0; i < codes.length; i += 1) {
        var code = codes[i].value;
        if (digits.indexOf(code) === 0) {
          return { code: code, local: digits.slice(code.length) };
        }
      }
      return { code: '', local: digitsOnly(raw) };
    }

    return { code: '', local: digitsOnly(raw) };
  }

  function pickDefaultCode(select, iso) {
    if (!iso) return;
    var match = Array.from(select.options).find(function (opt) {
      return opt.getAttribute('data-iso') === iso;
    });
    if (match) select.value = match.value;
  }

  function syncHidden(root) {
    var select = root.querySelector('.contact-phone__code');
    var local = root.querySelector('.contact-phone__local');
    var hidden = root.querySelector('#ContactForm-phone');
    if (!select || !local || !hidden) return;

    var localDigits = digitsOnly(local.value);
    hidden.value = localDigits ? select.value + localDigits : '';
  }

  function init(root) {
    var select = root.querySelector('.contact-phone__code');
    var local = root.querySelector('.contact-phone__local');
    var hidden = root.querySelector('#ContactForm-phone');
    var form = root.closest('form');
    if (!select || !local || !hidden) return;

    var codes = getCodes(select);
    var stored = root.getAttribute('data-phone-value') || hidden.value || '';
    var parsed = splitPhone(stored, codes);

    pickDefaultCode(select, root.getAttribute('data-default-iso'));
    if (parsed.code) {
      var codeOpt = Array.from(select.options).find(function (opt) {
        return opt.value === parsed.code;
      });
      if (codeOpt) select.value = parsed.code;
    }
    if (parsed.local) local.value = parsed.local;

    syncHidden(root);

    function onChange() {
      syncHidden(root);
    }

    select.addEventListener('change', onChange);
    local.addEventListener('input', onChange);
    local.addEventListener('blur', onChange);

    if (form) {
      form.addEventListener('submit', onChange);
    }
  }

  function boot() {
    document.querySelectorAll('[data-contact-phone]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
